import React, { useState } from 'react';
import './ActivityLog.css';
import { formatTimeAgo } from '../utils/helpers';

function ActivityLog({ activities = [] }) {
  const [filter, setFilter] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');

  // Mock activities if none provided
  const defaultActivities = [
    { id: 1, type: 'user', action: 'User registered', user: 'NewUser123', timestamp: new Date(Date.now() - 5 * 60000), details: 'New user account created' },
    { id: 2, type: 'giveaway', action: 'Giveaway created', user: 'Founder', timestamp: new Date(Date.now() - 60 * 60000), details: 'Discord Nitro Giveaway' },
    { id: 3, type: 'entry', action: 'User entered giveaway', user: 'LuckyUser', timestamp: new Date(Date.now() - 120 * 60000), details: 'Entered Discord Nitro Giveaway' },
    { id: 4, type: 'admin', action: 'User banned', user: 'Admin', timestamp: new Date(Date.now() - 180 * 60000), details: 'Banned user: Spammer123' },
    { id: 5, type: 'giveaway', action: 'Giveaway ended', user: 'System', timestamp: new Date(Date.now() - 240 * 60000), details: 'Winner: Winner123' },
    { id: 6, type: 'user', action: 'Account locked', user: 'Admin', timestamp: new Date(Date.now() - 300 * 60000), details: 'Locked account: SuspiciousUser' },
    { id: 7, type: 'entry', action: 'Boost activated', user: 'User456', timestamp: new Date(Date.now() - 360 * 60000), details: '2x Entry Boost' },
    { id: 8, type: 'admin', action: 'Permission updated', user: 'Founder', timestamp: new Date(Date.now() - 420 * 60000), details: 'Updated admin permissions' },
  ];

  const allActivities = activities.length > 0 ? activities : defaultActivities;

  const filteredActivities = allActivities.filter(activity => {
    const matchesFilter = filter === 'all' || activity.type === filter;
    const matchesSearch = !searchQuery || 
      activity.user.toLowerCase().includes(searchQuery.toLowerCase()) ||
      activity.action.toLowerCase().includes(searchQuery.toLowerCase()) ||
      activity.details.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesFilter && matchesSearch;
  });

  const getActivityIcon = (type) => {
    switch (type) {
      case 'user': return '👤';
      case 'giveaway': return '🎁';
      case 'entry': return '🎯';
      case 'admin': return '🛡️';
      case 'system': return '⚙️';
      default: return '📝';
    }
  };

  const getActivityColor = (type) => {
    switch (type) {
      case 'user': return '#3b82f6';
      case 'giveaway': return '#10de82';
      case 'entry': return '#f59e0b';
      case 'admin': return '#ef4444';
      case 'system': return '#6361e7';
      default: return '#aab1c7';
    }
  };

  return (
    <div className="activity-log-page">
      <div className="activity-log-container">
        <div className="activity-log-header">
          <h1>📋 Activity Log</h1>
          <p>Complete history of platform activities</p>
        </div>

        <div className="activity-log-controls">
          <div className="filter-buttons">
            <button
              className={filter === 'all' ? 'active' : ''}
              onClick={() => setFilter('all')}
            >
              All
            </button>
            <button
              className={filter === 'user' ? 'active' : ''}
              onClick={() => setFilter('user')}
            >
              Users
            </button>
            <button
              className={filter === 'giveaway' ? 'active' : ''}
              onClick={() => setFilter('giveaway')}
            >
              Giveaways
            </button>
            <button
              className={filter === 'entry' ? 'active' : ''}
              onClick={() => setFilter('entry')}
            >
              Entries
            </button>
            <button
              className={filter === 'admin' ? 'active' : ''}
              onClick={() => setFilter('admin')}
            >
              Admin
            </button>
          </div>
          <input
            type="text"
            placeholder="Search activities..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="activity-search"
          />
        </div>

        <div className="activity-log-list">
          {filteredActivities.length === 0 ? (
            <div className="empty-activity">
              <p>No activities found</p>
            </div>
          ) : (
            filteredActivities.map(activity => (
              <div
                key={activity.id}
                className="activity-item"
                style={{ borderLeftColor: getActivityColor(activity.type) }}
              >
                <div className="activity-icon" style={{ color: getActivityColor(activity.type) }}>
                  {getActivityIcon(activity.type)}
                </div>
                <div className="activity-content">
                  <div className="activity-header">
                    <span className="activity-action">{activity.action}</span>
                    <span className="activity-user">by {activity.user}</span>
                  </div>
                  <p className="activity-details">{activity.details}</p>
                  <span className="activity-time">{formatTimeAgo(activity.timestamp)}</span>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}

export default ActivityLog;

